import React from 'react'
import {ExitInterviewProfileInfo} from '../../organism'
import ProfileStyled from './styled'

const ProfileProcesses = () => {
  return (
    <ProfileStyled>
      <ExitInterviewProfileInfo/>
    </ProfileStyled>
  )
}

export default ProfileProcesses
